export default "__VITE_ASSET__CMm8Svke__"